<template>
    <l-layout :layout="['xs121']">
      <v-layout column>
        <v-layout justify-center class="mt-5">
          <v-icon size="150" color="yellow lighten-2">mdi-currency-usd</v-icon>
        </v-layout>
        <v-layout justify-center class="mt-2">
          <p style="font-size: 30px">账户余额:{{userLeft/100}}元</p>
        </v-layout>
        <v-layout justify-center column class="pl-5 pr-5">
            <v-btn class="primary" @click="goToUseDetail()">钱包明细</v-btn>
        </v-layout>
        <v-layout justify-center column class="pl-5 pr-5">
          <v-btn class="primary" @click="rechargeInfo.activated = true">点击充值</v-btn>
        </v-layout>
      </v-layout>
      <v-dialog width="350px" v-model="rechargeInfo.activated" persistent>
        <v-layout column justify-center>
          <v-card>
            <v-subheader>钱包充值</v-subheader>
            <v-form ref="rechargeForm" class="pa-3" v-if="!loading">
              <v-layout column>
                <v-flex xs12>
                  <v-select :items="rechargeInfo.rechargeItems" item-text="value" item-value="value" v-model="rechargeInfo.rechargeSelect" label="充值金额选择"
                  prepend-icon="mdi-currency-usd"></v-select>
                </v-flex>
                <v-flex xs12 v-if="rechargeInfo.rechargeSelect === '其他'">
                 <v-text-field label="请填写充值金额" prepend-icon="mdi-currency-usd" v-model="rechargeInfo.amount"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
            <v-container align-center fill-height v-else>
              <v-layout align-center class="pt-4" column style="height: 200px">
                <v-progress-circular
                  :color="'accent'"
                  :value="100"
                  size="50"
                  indeterminate
                ></v-progress-circular>
                <!--<v-btn @click="goTo()">跳转</v-btn>-->
                <span class="pt-3" style="font-size: 20px">正在创建订单...</span>
              </v-layout>
            </v-container>
            <v-card-actions>
              <v-layout justify-center>
                <v-btn  color="error" @click="rechargeInfo.activated=false">取消</v-btn>
                <v-btn  color="primary" @click="recharge" :loading="loading">提交</v-btn>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-dialog>
    </l-layout>
</template>

<script>
import wx from 'weixin-js-sdk'
export default {
  name: 'purseDetail',
  data () {
    return {
      userLeft: '',
      showDetails: false,
      type: 'use',
      loading: false,
      rechargeInfo: {
        amount: '',
        activated: false,
        rechargeItems: [
          {isSelect: false, value: '20'},
          {isSelect: false, value: '50'},
          {isSelect: false, value: '100'},
          {isSelect: false, value: '200'},
          {isSelect: false, value: '其他'},
        ],
        rechargeSelect: ''
      },
    }
  },
  computed: {
    userLeftLabel () {
      return '用户钱包(钱包余额:' + this.userLeft + ')'
    }
  },
  methods: {
    getUserInfo () {
      return JSON.parse(sessionStorage.getItem('loginInfo'))
    },
    async getUserDetail () {
      let p = await this.$store.dispatch('login/getSelfInfo')
      let params = {
        'searchParam': {
          'userId': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': p.id,
                'operator': 'EQ',
                'matchType': 'NONE'
              }
            ]
          }
        }
      }
      try {
        let res = await this.$store.dispatch('pay/getUserInfo', params)
        if (res.data.status + '' === '200') {
          if (res.data.data.content.length === 0) {
            // this.$L.alert('error', {message: '未查询到该用户'})
            return
          }
          else {
            this.userLeft = res.data.data.content[0].balance
          }
        }
      }
      catch (e) {
        console.log(e)
      }
    },
    goToUseDetail () {
      this.$router.push({name: 'purseUseDetail_wx'})
    },
    async createOrder () {
      let params = {
        'userId': this.billInfo.userId,
        'plateNum': this.billInfo.plateNumb,
        'billId': this.billId
      }
      let res = await this.$store.dispatch('pay/createOrder', params)
      if (res.data.status + '' === '200') {
        // alert('创建订单成功')
        this.$L.alert('success', {message: '创建订单成功'})
        // let data = JSON.parse(res.data.data)
        // console.log(data.package)
        this.wexinPay(JSON.parse(res.data.data))
      }
      else {
        this.$L.alert('error', {message: '创建订单失败，原因:' + res.data.msg})
      }
    },
    wexinPay (data) {
      let appId = 'wxfd33224488b5cf00'
      let timestamp = data.timeStamp
      let nonceStr = data.nonceStr
      let signature = data.signature
      let packages = data.package
      let paySign = data.paySign
      let _this = this
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appId, // 必填，公众号的唯一标识
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr: nonceStr, // 必填，生成签名的随机串
        signature: signature, // 必填，签名，见附录1
        jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      })
      wx.ready(function () {
        wx.chooseWXPay({
          timestamp: timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: nonceStr, // 支付签名随机串，不长于 32 位
          package: packages, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
          signType: 'MD5', // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: paySign, // 支付签名
          success: function (res) {
            // 支付成功后的回调函数
            _this.rechargeInfo.activated = false
            _this.getUserDetail()
            alert('支付成功')
          },
          fail: function (res) {
            // this.$L.alert('error', {message: '支付失败'})
            alert('支付失败')
          }
        })
      })
      wx.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        alert('config信息验证失败')
      })
    },
    async recharge () {
      if (!this.$refs.rechargeForm.validate()) {
        this.$L.alert('error', {message: '表单数据有误'})
        return
      }
      if (this.rechargeInfo.rechargeSelect !== '其他') {
        this.rechargeInfo.amount = this.rechargeInfo.rechargeSelect
      }
      let p = await this.$store.dispatch('login/getSelfInfo')
      let params = {
        'amount': this.rechargeInfo.amount,
        'userId': p.id,
      }
      this.loading = true
      let res = await this.$store.dispatch('pay/recharge', params)
      this.loading = false
      if (res.data.status + '' === '200') {
        let params = JSON.parse(res.data.data)
        this.wexinPay(params)
      }
      else {
        this.$L.alert('error', {message: '创建订单失败'})
      }
    }
  },
  created () {
    this.getUserDetail()
  }
}
</script>

<style scoped>

</style>
